import { useGetApplication } from 'app/hooks';

import { type EconomyActivity } from './types';
export const baseUrl = '/operations';
export const useOperationsList = () => {
  const response = useGetApplication<Array<EconomyActivity>>({
    url: baseUrl,
    params: {}
  });

  return response;
};
